import { actionTypes } from "constants/Reports/harvest/contractorReport";

const initialState = {
  data: {
    content: [],
    page: {},
    isFetching: false
  },
  list: {
    content: [],
    isFetching: false
  },
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CONTRACTOR_REPORT_TABLE_DATA_START:
      return {
        ...state,
        data: {
          ...state.data,
          isFetching: true
        }
      };
    case actionTypes.FETCH_CONTRACTOR_REPORT_TABLE_DATA:
      return {
        ...state,
        data: {
          ...action.payload,
          isFetching: false
        }
      };
    case actionTypes.FETCH_CONTRACTOR_REPORT_TABLE_DATA_FAILED:
      return {
        ...state,
        data: {
          ...state.data,
          isFetching: false
        },
        error: action.error
      };
    case actionTypes.FETCH_CONTRACTOR_REPORT_TABLE_LIST_START:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true
        }
      };
    case actionTypes.SET_CONTRACTOR_REPORT_TABLE_LIST:
      return {
        ...state,
        list: {
          ...action.payload,
          isFetching: false
        }
      };
    case actionTypes.FETCH_CONTRACTOR_REPORT_TABLE_LIST_FAILED:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false
        },
        error: action.error
      };
    default:
      return state;
  }
};
